import appApi from '../../../../api/app-api';
import globalPaymentServices from '../../../../stores/global-payment-services';
import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../api/errors/api-error-codes';

export const editPaymentServiceNameOperation = async (
  paymentServiceId: number,
  paymentServiceName: string,
  setLoading: (loading: boolean) => void,
) => {
  try {
    setLoading(true);

    const res = await appApi.updatePaymentServiceName(
      paymentServiceId,
      paymentServiceName,
    );
    if (res.data.ok) {
      globalPaymentServices.fetchPaymentService();
    } else if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
    }
    setLoading(false);
  } catch (e) {
    setLoading(false);
    console.error(
      `editPaymentServiceNameOperation failed with paymentServiceId: ${paymentServiceId}, and error: ${e}`,
    );
    toast.error(`משהו קרה, נסה שוב בעוד מספר רגעים...`);
  }
};
